CounterUp = function () {
    var init = function () {
        $('.counter').each(function () {
            var $this = $(this);
            var endResult = $this.text();
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1500,
                easing: 'swing',
                step: function () {
                    var num = Math.ceil(this.Counter).toString();
                    if (Number(num) > 999) {
                        while (/(\d+)(\d{3})/.test(num)) {
                            num = num.replace(/(\d+)(\d{3})/, '$1' + ' ' + '$2');
                        }
                    }
                    $this.text(num);
                },
                complete : function () {
                    if (Number(endResult) > 999) {
                        while (/(\d+)(\d{3})/.test(num)) {
                            endResult = endResult.replace(/(\d+)(\d{3})/, '$1' + ' ' + '$2');
                        }
                    }
                    $this.text(endResult);
                }
            });
        });
    };
    return {
        init: init
    };
}();